import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/zoom2.png";
import Imagen2 from "../../../images/modulo13/zoom3.png";

const Actividad1 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[3];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[4].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[4].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[2].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[2].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5">
        <div className="row mt-3 align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
          <h2 className="mb-4">Un territorio con una gran diversidad de recursos</h2>

            <p>
              La diversidad de nuestro territorio hace que tengamos una enorme
              <strong>variedad de recursos naturales</strong>. Entre ellos están los bosques, los
              glaciares, los ríos y lagos, la flora, la fauna, el petróleo, los
              minerales, el gas natural, etc.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-3 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-9 col-12 p-4 p-md-3">
            <p>
              <strong>La explotación adecuada</strong> de los recursos naturales juega un papel
              muy importante en la economía peruana.
            </p>
            <p>
              El crecimiento económico y poblacional del país debe ir de la mano
              con leyes que contribuyan a la <strong>protección</strong> de los recursos
              naturales.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean el texto titulado Un
            territorio con una gran diversidad de recursos. Lea nuevamente en
            voz alta el texto. Pida que señalen las ideas más
            importantes presentadas en el texto: el Perú es un país con una gran
            diversidad de recursos naturales. Estos juegan un rol fundamental en
            la economía peruana. Es importante que se tome en cuenta cómo se
            afectan los recursos naturales con el fin de protegerlos.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
